
const getDefaultState = () => {
  return {
    type: null,
    message: null
  }
}

const state = getDefaultState()

const actions = {
  set ({ commit }, { type, message }) {
    commit('set', { type, message })
    setTimeout(() => {
      commit('resetState')
    }, 7000)
  },
  resetStateAction ({ commit }) {
    commit('resetState')
  }
}

const mutations = {
  set (state, { type, message }) {
    state.type = type
    state.message = message
  },
  resetState (state) {
    Object.assign(state, getDefaultState())
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
